import { render, staticRenderFns } from "./VerifyPhoneForm.vue?vue&type=template&id=371ce9ce&scoped=true"
import script from "./VerifyPhoneForm.vue?vue&type=script&lang=js"
export * from "./VerifyPhoneForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ce9ce",
  null
  
)

export default component.exports